import { render, staticRenderFns } from "./CouponWithDiscountForm.vue?vue&type=template&id=bb71b010"
import script from "./CouponWithDiscountForm.vue?vue&type=script&lang=js"
export * from "./CouponWithDiscountForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports